import { render, staticRenderFns } from "./ClockStats.vue?vue&type=template&id=866c5df0&scoped=true&"
import script from "./ClockStats.vue?vue&type=script&lang=js&"
export * from "./ClockStats.vue?vue&type=script&lang=js&"
import style0 from "./ClockStats.vue?vue&type=style&index=0&id=866c5df0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866c5df0",
  null
  
)

export default component.exports